import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { UploadCloud, Trash2, Image as ImageIcon, Sparkles, Layers, List } from 'lucide-react';
import './AdminSlider.css';

const API_URL = 'https://api.sohanihandicrafts.com:5010';

const AdminSlider = () => {
    const [slides, setSlides] = useState([]);
    const [title, setTitle] = useState('');
    const [subtitle, setSubtitle] = useState('');
    const [effect, setEffect] = useState('blocks');
    const [slideImage, setSlideImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const fileInputRef = useRef(null);

    const fetchSlides = async () => {
        try {
            const res = await axios.get(`${API_URL}/api/slider/all`);
            setSlides(res.data);
        } catch (err) { console.error(err); }
    };

    useEffect(() => { fetchSlides(); }, []);

    const handleFile = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSlideImage(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!slideImage) return Swal.fire('Error', 'Title and Image are required', 'error');

        const formData = new FormData();
        formData.append('title', title);
        formData.append('subtitle', subtitle);
        formData.append('effect', effect);
        formData.append('slideImage', slideImage);

        try {
            await axios.post(`${API_URL}/api/slider/add`, formData);
            Swal.fire('Success', 'Hero slide added!', 'success');
            setTitle(''); setSubtitle(''); setEffect('blocks'); setSlideImage(null); setPreview(null);
            fetchSlides();
        } catch (err) { Swal.fire('Error', 'Failed to save slide', 'error'); }
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Delete this slide?',
            text: "This will remove it from the home page hero section.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await axios.delete(`${API_URL}/api/slider/delete/${id}`);
                fetchSlides();
            }
        });
    };

    return (
        <div className="adm-sld-wrapper">
            <div className="adm-sld-header">
                <h1>Hero Slider Management</h1>
                <p>Configure the visuals and animations for your homepage</p>
            </div>

            <div className="adm-sld-layout">
                {/* --- ADD SLIDE FORM --- */}
                <div className="adm-sld-card">
                    <div className="adm-sld-card-title">
                        <ImageIcon size={20} color="#C5A059" />
                        <h3>Create New Slide</h3>
                    </div>
                    <form onSubmit={handleSubmit} className="adm-sld-form">
                       

                       
                        <div className="adm-sld-upload-area" onClick={() => fileInputRef.current.click()}>
                            <input type="file" hidden ref={fileInputRef} onChange={handleFile} accept="image/*" />
                            {preview ? <img src={preview} alt="preview" /> : 
                            <div className="adm-sld-placeholder">
                                <UploadCloud size={40} />
                                <span>Click to upload High-Res Banner</span>
                            </div>}
                        </div>
                         <div className="adm-sld-input-row">
                           
                            <div className="adm-sld-group">
                                <label>Animation Effect</label>
                                <select value={effect} onChange={(e) => setEffect(e.target.value)}>
                                    <option value="blocks">Blocks (Grid Entrance)</option>
                                    <option value="lines">Lines (Vertical Curtains)</option>
                                    <option value="shutters">Shutters (Horizontal)</option>
                                </select>
                            </div>
                        </div>

                        <button type="submit" className="adm-sld-submit">Publish Slide</button>
                    </form>
                </div>

                {/* --- LIST VIEW --- */}
                <div className="adm-sld-card">
                    <div className="adm-sld-card-title">
                        <List size={20} color="#C5A059" />
                        <h3>Active Slides ({slides.length})</h3>
                    </div>
                    <div className="adm-sld-table-wrapper">
                        <table className="adm-sld-table">
                            <thead>
                                <tr>
                                    <th>Preview</th>
                                    
                                    <th>Animation</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {slides.map((s) => (
                                    <tr key={s._id}>
                                        <td><img src={`${API_URL}/${s.image}`} className="adm-sld-thumb" alt="s" /></td>
                                       
                                        <td><span className="adm-sld-effect-tag">{s.effect}</span></td>
                                        <td>
                                            <button className="adm-sld-del-btn" onClick={() => handleDelete(s._id)}>
                                                <Trash2 size={18} />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminSlider;